import React from "react";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import { useRecentCustomLocationsBySearch } from "@coworker/apprestructured/src/tasks/hooks/useRecentCustomLocationsBySearch";
import { useRecentCustomLocationsForItem } from "@coworker/apprestructured/src/tasks/hooks/useRecentCustomLocationsForItem";
import { makePartialMatcher } from "@coworker/utils/location.helper";

const queryFilter = (query: string, locations: string[]) => {
  const partialMatch: (matchValue: string) => boolean =
    makePartialMatcher(query);
  return locations.filter(partialMatch);
};

export function useRecentCustomLocations(
  query: string,
  short_id: string,
  taskType: TaskType,
  onlyPickups: boolean
) {
  const { data: itemCustomLocations, isLoading: isItemCustomLocationsLoading } =
    useRecentCustomLocationsForItem(short_id, taskType);

  const {
    data: searchCustomLocations,
    isLoading: isSearchCustomLocationsLoading,
  } = useRecentCustomLocationsBySearch(query, taskType);

  return React.useMemo(() => {
    const key = onlyPickups ? "pickups" : "refills";
    if (isItemCustomLocationsLoading || isSearchCustomLocationsLoading)
      return { loading: true, customLocations: [] };
    const fromQuery = searchCustomLocations?.[key] || [];
    const fromShortId = itemCustomLocations?.[key] || [];
    const set = new Set([...fromQuery, ...fromShortId]);
    return { loading: false, customLocations: queryFilter(query, [...set]) };
  }, [
    itemCustomLocations,
    isItemCustomLocationsLoading,
    searchCustomLocations,
    isSearchCustomLocationsLoading,
    query,
    onlyPickups,
  ]);
}
